import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { breakpoints } from '../../hooks/useMediaQuery';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isMobile = !useMediaQuery(breakpoints.md);
  const location = useLocation();

  useEffect(() => {
    if (!isMobile && isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [isMobile, isMenuOpen]);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-[#040d16] text-white">
      <Header className="absolute top-0 left-0 z-50 w-full bg-transparent" />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
